import { SearchItem } from './module';

export const FundModuleId = 'Fund' as const;

//Legacy

//V1
export interface FundSearchItemDataV1 {
  fundId: string;
  name: string;
}

export const FundSearchItemVersionV1 = '1' as const;

export interface FundSearchItemV1 extends SearchItem<FundSearchItemDataV1> {
  version: typeof FundSearchItemVersionV1;
  moduleId: typeof FundModuleId;
}

export type LegacyFundSearchItem = FundSearchItemV1;

// Current

export type FundSearchItemData = FundSearchItemDataV1;

export const FundSearchItemVersion = FundSearchItemVersionV1;

export type FundSearchItem = FundSearchItemV1;

export const createFundSearchItem = (fund: { label?: string; tagId: string }): FundSearchItem => ({
  data: {
    fundId: fund.tagId,
    name: fund.label ?? '',
  },
  id: fund.tagId,
  moduleId: FundModuleId,
  version: FundSearchItemVersion,
});

export const isLegacyFundSearchItem = (item: SearchItem): item is LegacyFundSearchItem =>
  item.moduleId === FundModuleId;

export const isFundSearchItem = (item: SearchItem): item is FundSearchItem =>
  item.moduleId === FundModuleId && item.version === FundSearchItemVersion;
